export default __webpack_public_path__ + "static/media/misc-closetA-1024w.d7f86a78.webp";